module.exports = __webpack_public_path__ + "static/full04-83493477555338a2820c333f071bf78b.png";